import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { calculateRem } from "@uie/javascript-style-helpers";
import { TextLink as CoreTextLink } from "@vds-core/buttons";
import { colors } from "@vds/theme";
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false
};

var _calculateColors = function _calculateColors(surface) {
  return {
    "default": surface === "dark" ? colors.white : colors.black,
    hover: surface === "dark" ? colors.blueInverted : colors.blue,
    active: colors.coolGray6,
    disabled: surface === "dark" ? colors.coolGray10 : colors.coolGray3
  };
};

var _calculateUnderLine = function _calculateUnderLine(calculateColors, surface) {
  var color = calculateColors(surface);
  return {
    "default": "".concat(calculateRem(1), " solid ").concat(color["default"]),
    hover: "".concat(calculateRem(1), " solid ").concat(color.hover),
    active: "".concat(calculateRem(1), " solid ").concat(color.active),
    disabled: "".concat(calculateRem(1), " solid ").concat(color.disabled)
  };
};

var _calculateLetterSpacing = function _calculateLetterSpacing(size) {
  var letterSpacing = "0px";

  if (size === "large") {
    letterSpacing = "0.5px";
  }

  return letterSpacing;
};

var TextLink = function TextLink(props) {
  return /*#__PURE__*/React.createElement(CoreTextLink, _extends({}, props, {
    surface: props.inverted ? "dark" : "light",
    calculateColors: _calculateColors,
    calculateUnderLine: _calculateUnderLine,
    calculateLetterSpacing: _calculateLetterSpacing,
    focusRingBorderRadius: "0"
  }));
};

TextLink.propTypes = propTypes;
TextLink.defaultProps = defaultProps;
export default TextLink;